/* @generated */

// src/assets/ui-icon/line/ordered-list.tsx
import * as React from "react";
var OrderedListLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M4.497 7.5v1H7v-1h-.723v-3h-.832a.926.926 0 0 1-.272.463.912.912 0 0 1-.508.19v.742h.6V7.5h-.768Zm2.461 9.436a.771.771 0 0 0 .404-.307.972.972 0 0 0 .133-.533.958.958 0 0 0-.386-.795 1.81 1.81 0 0 0-1.13-.3 1.808 1.808 0 0 0-1.188.341 1.17 1.17 0 0 0-.409.95v.208h.99v-.167a.45.45 0 0 1 .143-.346.6.6 0 0 1 .421-.133.645.645 0 0 1 .417.111.364.364 0 0 1 .131.294.326.326 0 0 1-.117.274.634.634 0 0 1-.383.091h-.35v.704h.35a.875.875 0 0 1 .404.073.286.286 0 0 1 .135.276.378.378 0 0 1-.15.313.723.723 0 0 1-.45.118.661.661 0 0 1-.447-.122.47.47 0 0 1-.135-.367V17.5H4.335v.172a1.281 1.281 0 0 0 .365.994c.355.256.79.375 1.227.334a1.95 1.95 0 0 0 1.223-.328 1.05 1.05 0 0 0 .417-.866.91.91 0 0 0-.164-.58.887.887 0 0 0-.444-.29ZM20 16.5H9.5V18H20v-1.5Zm0-5.5H9.5v1.5H20V11Zm0-5.5H9.5V7H20V5.5ZM4.5 11.75A1.16 1.16 0 0 0 5.75 13 1.161 1.161 0 0 0 7 11.75a1.16 1.16 0 0 0-1.25-1.25 1.16 1.16 0 0 0-1.25 1.25Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  OrderedListLine
};
